/**
 * Created by Ning Jiang on 10/16/2018.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {Timeline, TimelineLite} from "gsap";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";

export class TombstoneScatterSymbolWPController extends WinPresentationController {

    private _timeline:TimelineLite | null;
    private _freespinTriggered:boolean;
    private _scatterPositions:number[];

    constructor(indexes:[number, number]) {
        super(indexes, {name : "Scatters"})
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {
        this._freespinTriggered = data.freespinTriggeredThisSpin;
        this._scatterPositions = data.scatterPositions!;

        if(this._freespinTriggered && (
            this._scatterPositions == null ||
            this._scatterPositions[1] === -1 ||
            this._scatterPositions[2] === -1 ||
            this._scatterPositions[3] === -1)) {
            debugger;
            throw new Error("TombstoneScatterSymbolWPController.parseFeatureGameData(): scatterPositions data doesn't match the feature.")
        }
    }

    protected hasWin():boolean {
        return this._freespinTriggered;
    }

    protected startWinPresentation():void {
        const timeline:TimelineLite = new TimelineLite({paused : true, onComplete : () => this.finish()});
        timeline.add(() => SlotGame.sound.playEffect(TombstoneSoundConfig.instance.SCATTER_WIN), 0);
        timeline.add(this.getScatterSymbolAnimation(1, false), 0);
        timeline.add(this.getScatterSymbolAnimation(2, false), 0);
        timeline.add(this.getScatterSymbolAnimation(3, false), 0);
        this._timeline = timeline;
        this._timeline.play();
    }

    private getScatterSymbolAnimation(reelId:number, isAbort:boolean):Timeline | null {
        const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, this._scatterPositions[reelId]);
        if(symbol == null) {
            debugger;
            return null;
        }

        symbol.parent.addChild(symbol);
        return symbol.changeState({
            state : GameConfig.instance.SYMBOL_STATES.win,
            setStack : true,
            fadeInDuration : isAbort ? 0 : 0.1,
            frames : isAbort ? [-1, -1] : [0]
        })!;
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(this._timeline && this._timeline.isActive()) {
            this._timeline.pause();
            this._timeline.kill();
            this._timeline = null;
        }
        this.getScatterSymbolAnimation(1, true);
        this.getScatterSymbolAnimation(2, true);
        this.getScatterSymbolAnimation(3, true);
    }

    protected resetFeature():void {
    }
}